import { useCreation } from 'ahooks'
import { Checkbox } from 'antd'

import { DataError } from '@eastcoal/common/components/DataError'
import { pick } from '@eastcoal/common/utils/object'

import { useKindRootNodeStore } from '../../Store/hooks/useStore'

import { KindRootNodeCheckboxCoreProps } from './interface'

export const KindRootNodeCheckboxCore = ({
  disabled
}: KindRootNodeCheckboxCoreProps) => {
  const { data, error, loading, reload, selectedKeys, setSelectedKeys } =
    useKindRootNodeStore(state =>
      pick(state, [
        'data',
        'error',
        'loading',
        'reload',
        'multiple',
        'selectedKeys',
        'setSelectedKeys'
      ])
    )

  const options = useCreation(() => {
    return data?.map(item => ({
      label: item.name,
      value: `${item.id}`
    }))
  }, [data])

  return error ? (
    <DataError error={error} loading={loading} reload={reload} />
  ) : (
    <Checkbox.Group
      disabled={disabled}
      options={options}
      value={selectedKeys}
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(6, 1fr)',
        rowGap: 12
      }}
      onChange={setSelectedKeys as any}
    />
  )
}
